<template>
  <Bar
    :chart-data="convertedData"
    :chart-options="mergedOptions"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="convertedPlugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height" />
</template>

<script>
  import { Bar } from 'vue-chartjs'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

  import { merge, deepCopy } from 'utils/json'

  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  const LOCAL_CHART_OPTIONS = {
  };

  export default {
    name: 'BarChart',
    components: { Bar },
    props: {
      chartData: {
        type: Object,
        default: null,
      },
      chartOptions: {
        type: Object,
        default: null,
      },
      chartId: {
        type: String,
        default: 'bar-chart',
      },
      datasetIdKey: {
        type: String,
        default: 'label',
      },
      width: {
        type: Number,
        default: 0,
      },
      height: {
        type: Number,
        default: 0,
      },
      cssClasses: {
        default: '',
        type: String,
      },
      styles: {
        type: Object,
        default: () => { },
      },
      plugins: {
        type: Object,
        default: [],
      },
    },
    computed: {
      isHorizontalChart() {
        return this.mergedOptions.indexAxis === "y";
      },
    },
    methods: {
      convertData() {
        this.convertedData = deepCopy(this.chartData);
      },
      convertOptions() {
        this.mergedOptions = merge(this.chartOptions, LOCAL_CHART_OPTIONS);
      },
      convertPlugins() {
        this.convertedPlugins = Array.isArray(this.plugins) ? this.plugins : [this.plugins];
      },
    },
    data: () => {
      return {
        convertedData: {},
        mergedOptions: {},
        convertedPlugins: [],
      }
    },
    created() {
      this.convertData();
      this.convertOptions();
      this.convertPlugins();
    },
    watch: {
      chartData: {
        handler: function () {
          this.convertData();
          this.convertPlugins();
        },
        deep: true,
      },
      chartOptions: {
        handler: function () {
          this.convertOptions();
        },
        deep: true,
      },
    },
  }
</script>
